import { useEffect } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { VFX } from '@vfx-js/core'

import styles from '../styles/sections/Archive.module.scss'

const shader = `
precision highp float;
uniform vec2 resolution;
uniform vec2 offset;
uniform float time;
uniform sampler2D src;
uniform float scroll;
out vec4 outColor;

void main (void) {
    vec2 uv = (gl_FragCoord.xy - offset) / resolution;

    // Slower horizontal movement
    uv.x = fract(uv.x + scroll * 0.4 + time * 0.08);

    outColor = texture2D(src, uv);
}
`;

const mobileShader = `
uniform vec2 resolution;
uniform vec2 offset;
uniform float scroll;
uniform sampler2D src;
out vec4 outColor;

void main() {
    vec2 uv = (gl_FragCoord.xy - offset) / resolution;

    // Slower horizontal movement on mobile
    uv.x = fract(uv.x + scroll * 5.0);

    // prevent vertical overflow
    if (uv.y < 0. || uv.y > 1.) discard;

    outColor = texture2D(src, uv);
}
`;

const Archive = () => {
  useEffect(() => {
    const vfx = new VFX()
    const el = document.querySelector('#archive-heading')

    if (!el) return

    vfx.add(el, {
      shader: isMobile || isTablet ? mobileShader : shader,
      uniforms: {
        scroll: () => {
          if (isMobile || isTablet) {
            return (
              window.scrollY /
              (document.body.scrollHeight - window.innerHeight)
            )
          }

          return window.scrollY / window.innerHeight
        },
      },
    })

    return () => {
      vfx.remove(el)
    }
  }, [])

  return (
    <section id='archive' className={styles.archive}>
      <div id='archive-heading' className={styles.archive__heading}>
        Probably nothing
      </div>
    </section>
  )
}

export default Archive
